// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3DIJb","left":"StickyBox_left__3XbdP","right":"StickyBox_right__3qvqZ"};